import { useTranslation } from 'react-i18next';
import { ITableComponent } from '../Table';
import { ResourceCategory } from '../../../types/CustomResource';
import { PLAN_TYPE } from '../../../pages/ActionPlan/constants';
import {
  StyledTableBody,
  StyledTableCell,
  StyledTableRow,
  StyledTableSubtitle,
} from '../Table.styles';
import { CustomResources } from './CustomResources/CustomResources';
import { Status } from './Status/Status';

export const InitiativesTable = ({
  rows,
  columns,
  customResourcesData,
  initiativesStatusData,
  isPreviewMode,
  isCompleted,
}: ITableComponent) => {
  const { t } = useTranslation();
  const marketingInitiatives = rows?.filter((row) => row.resource === 'marketing');
  const educationInitiatives = rows?.filter((row) => row.resource === 'education');
  const careResources = rows?.filter((row) => row.resource === 'care');

  const shouldShowMarketingInitiativesTitle =
    !!marketingInitiatives.length ||
    (customResourcesData && !isPreviewMode) ||
    !!customResourcesData?.customResourcesApi.getResourcesByPlanTypeAndCategory({
      resources: customResourcesData.customResourcesApi.customResources,
      actionPlanType: PLAN_TYPE[customResourcesData.planTypeId].field,
      category: ResourceCategory.marketing,
    })?.length;
  const shouldShowEducationInitiativesTitle =
    !!educationInitiatives.length ||
    (customResourcesData && !isPreviewMode) ||
    !!customResourcesData?.customResourcesApi.getResourcesByPlanTypeAndCategory({
      resources: customResourcesData.customResourcesApi.customResources,
      actionPlanType: PLAN_TYPE[customResourcesData.planTypeId].field,
      category: ResourceCategory.education,
    })?.length;
  const shouldShowCareInitiativesTitle =
    !!careResources.length ||
    (customResourcesData && !isPreviewMode) ||
    !!customResourcesData?.customResourcesApi.getResourcesByPlanTypeAndCategory({
      resources: customResourcesData.customResourcesApi.customResources,
      actionPlanType: PLAN_TYPE[customResourcesData.planTypeId].field,
      category: ResourceCategory.care,
    })?.length;

  return (
    <>
      <StyledTableBody>
        {shouldShowMarketingInitiativesTitle && (
          <StyledTableSubtitle>{t('marketingResources')}</StyledTableSubtitle>
        )}
        {!!marketingInitiatives.length &&
          marketingInitiatives.map((row) => {
            return (
              <StyledTableRow key={(row.id || row.kpi) as string}>
                {columns.map((cell) => (
                  <StyledTableCell
                    key={row.id + cell.id}
                    component="th"
                    scope="row"
                    styledBgColor={!!row.intlBenchmarkKpi && cell.id === 'globalBenchmarkKpi'}
                  >
                    {row[cell.id] as string}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            );
          })}
        {customResourcesData && (
          <CustomResources
            category={ResourceCategory.marketing}
            planTypeId={customResourcesData.planTypeId}
            columns={columns}
            customResourcesApi={customResourcesData.customResourcesApi}
            isPreviewMode={isPreviewMode}
            onCheckboxClick={customResourcesData.onCheckboxClick}
            initiativesStatusData={initiativesStatusData}
            selectedItems={customResourcesData.selectedItems[customResourcesData.planTypeId]}
          />
        )}
        {shouldShowEducationInitiativesTitle && (
          <StyledTableSubtitle>{t('educationResources')}</StyledTableSubtitle>
        )}
        {!!educationInitiatives.length &&
          educationInitiatives.map((row) => {
            return (
              <StyledTableRow key={(row.id || row.kpi) as string}>
                {columns.map((cell) => (
                  <StyledTableCell
                    key={row.id + cell.id}
                    component="th"
                    scope="row"
                    styledBgColor={!!row.intlBenchmarkKpi && cell.id === 'globalBenchmarkKpi'}
                  >
                    {row[cell.id] as string}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            );
          })}
        {customResourcesData && (
          <CustomResources
            category={ResourceCategory.education}
            planTypeId={customResourcesData.planTypeId}
            columns={columns}
            customResourcesApi={customResourcesData.customResourcesApi}
            isPreviewMode={isPreviewMode}
            onCheckboxClick={customResourcesData.onCheckboxClick}
            initiativesStatusData={initiativesStatusData}
            selectedItems={customResourcesData.selectedItems[customResourcesData.planTypeId]}
          />
        )}
        {shouldShowCareInitiativesTitle && (
          <StyledTableSubtitle>{t('careResources')}</StyledTableSubtitle>
        )}
        {!!careResources.length &&
          careResources.map((row) => {
            return (
              <StyledTableRow key={(row.id || row.kpi) as string}>
                {columns.map((cell) => (
                  <StyledTableCell
                    key={row.id + cell.id}
                    component="th"
                    scope="row"
                    styledBgColor={!!row.intlBenchmarkKpi && cell.id === 'globalBenchmarkKpi'}
                  >
                    {row[cell.id] as string}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            );
          })}
        {customResourcesData && (
          <CustomResources
            category={ResourceCategory.care}
            planTypeId={customResourcesData.planTypeId}
            columns={columns}
            customResourcesApi={customResourcesData.customResourcesApi}
            isPreviewMode={isPreviewMode}
            onCheckboxClick={customResourcesData.onCheckboxClick}
            initiativesStatusData={initiativesStatusData}
            selectedItems={customResourcesData.selectedItems[customResourcesData.planTypeId]}
          />
        )}
      </StyledTableBody>
      {initiativesStatusData?.initiativesStatusApi && isCompleted && (
        <Status
          initiativesStatusApi={initiativesStatusData.initiativesStatusApi}
          planTypeId={customResourcesData.planTypeId}
        />
      )}
    </>
  );
};
